// extracted by mini-css-extract-plugin
export default {"card":"file-card_card__vwJO0","image":"file-card_image__jxwIJ","loading":"file-card_loading__Uc1wQ"};